export default __webpack_public_path__ + "media/images/home-over-7e5f2cbebc4f6f7f738da9fb2a34dc1b.png";